import React, { useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { createEmbeddingContext } from 'amazon-quicksight-embedding-sdk';
import { Spinner } from 'reactstrap';
import { fetchQSEmbedUrl, getStatePermissionMap } from '../../actions/reports';


function Quicksight() {
  const ref = useRef();
  const { report_access: reportAccess = [] } = useSelector(store => store.user);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const report = params.get('rid');
    const type = params.get('aws');
    const statePerms = Boolean(params.get('statePerms') === '1');

    fetchQSEmbedUrl(report, type).then(({ data }) => {
      (async () => {
        // Clear out the spinners.
        ref.current.innerHTML = '';

        /* amazon-quicksight-embedding-sdk v1.18.1
        QuickSightEmbedding.embedDashboard({
          url: data,
          container: ref.current,
          scrolling: 'yes',
          height: '100%',
          width: '100%',
        });
        */

        let url = data;

        if (statePerms) {
          const rawPerms = await getStatePermissionMap();
          const perms = rawPerms.map(p => ({ state: p.Abbr, key: p.StateAuthorizationKey }));

          // generate hash params string
          reportAccess.forEach((s, i) => {
            const { key } = (perms.find(p => (p.state === s)) || {});
            if (i === 0) {
              url += `#p.StateAuthorizationKey=${key}`;
            } else {
              url += `&p.StateAuthorizationKey=${key}`;
            }
          });
        }

        createEmbeddingContext()
          .then((context) => {
            const { embedDashboard } = context;
            embedDashboard({
              url,
              container: ref.current,
              scrolling: 'yes',
              height: '100%',
              width: '100%',
            });
          });
      })();
    });
  }, []);

  return (
    <main className="bg-white power-bi">
      <div id="powerbi-embed-div" ref={ref}>
        {/* NOTE: This spinner is automatically removed by the embed process. */}
        <div className="d-flex align-items-center justify-content-center h-100">
          <Spinner color="info" style={{ width: '6rem', height: '6rem' }} type="grow" />
          <Spinner color="info" style={{ width: '6rem', height: '6rem' }} type="grow" />
          <Spinner color="info" style={{ width: '6rem', height: '6rem' }} type="grow" />
        </div>
      </div>
    </main>
  );
}

export default Quicksight;
